import * as React from "react";

import type { ConfirmationDialogContextPayload } from "./types";

const ConfirmationDialogContext = React.createContext({} as ConfirmationDialogContextPayload);

export const ConfirmationDialogProvider = ConfirmationDialogContext.Provider;

export function useConfirmationDialog(): ConfirmationDialogContextPayload {
  const context = React.useContext(ConfirmationDialogContext);

  if (!context) {
    throw new Error("useConfirmationDialog should be within ConfirmationDialogProvider");
  }

  return context;
}
